import {GROUP_TYPE_NIUM} from '../../../../../../api/admin/payout/constants';
import formatTime from 'mn-utils/formatTime';
import {apiAdminPayoutGroupGet} from '../../../../../../api/admin/payout';
import React from 'react';
import * as links from '../../../../../../constants/links';
import withState from '../../../../../../utils/withState';
import LayoutB from '../../../../../dumb/Layout/B';
import CaptionA from '../../../../../dumb/Caption/A';
import HeaderA from '../../../../../dumb/Header/A';
import ButtonBack from '../../../../../dumb/Button/Back';
import WrapperWithLoading from '../../../../../dumb/WrapperWithLoading';
import Field from '../../../../../dumb/Field/A';
import {Link} from '../../../../../../router';
import GroupPlan from './GroupPlan';
import KrakenWithdrawsTable from './KrakenWithdrawsTable';
import PayoutsTable from './PayoutsTable';

module.exports = withState((setState, self, onMount) => {
  onMount(() => {
    const {id} = self.props.params;
    const params = {
      group_id: id,
      group_type: GROUP_TYPE_NIUM,
    };
    apiAdminPayoutGroupGet(params).then((data) => {
      setState(data);
    });
  });

  return (state, props) => {
    const params = props.params || {};
    const {
      id,
    } = params;

    const withdrawalDate = state.created_at || null;
    const amount = state.amount || '';
    const flow = state.flow || '';
    const flowDetails = state.flow_details || {};
    const groupPlan = flowDetails.group_plan || {};
    const payouts = flowDetails.payouts || [];
    let currency = '';
    if (payouts[0]) {
      currency = payouts[0].currency || currency;
    }

    const fee = state.expected_total_fees || '';
    const status = state.status || '';
    const krakenWithdraws = state.kraken_withdraws || [];
    const details = state.fx_details || '';
    const date = formatTime(withdrawalDate, '{dd} {mmm}, {yyyy}');
    const time = formatTime(withdrawalDate, '{hh}:{MM}:{ss} {TT}');

    return (
      <LayoutB>
        <HeaderA>
          <CaptionA
            className="fx1 wmin0"
            description={id}
          >
            Nium payout group info
          </CaptionA>
          <ButtonBack
            component={Link}
            href={links.LINK_ADMIN_PAYOUT_GROUPS}
          />
        </HeaderA>
        <WrapperWithLoading
          className="mt30"
          loading={state.loading}
        >
          <div className="mh-10 layoutRow fhaS fvaC (ph10|fx1)>1">
            <Field label="Amount">{amount}</Field>
            <Field label="Currency">{currency}</Field>
            <Field label="Date">{date}</Field>
            <Field label="Time">{time}</Field>
          </div>

          <div className="mt20 cfx mh-10 (lt|w1/2|ph10)>1">
            <Field label="Fee">{fee}</Field>
            <Field label="Status">{status}</Field>
            <Field label="Flow">{flow}</Field>
            <Field label="Details">{details}</Field>
          </div>
          <hr className="wmin830 mv50"/>

          <GroupPlan groupPlan={groupPlan}/>
          <hr className="wmin830 mv50"/>

          <KrakenWithdrawsTable
            groupId={id}
            currency={currency}
            krakenWithdraws={krakenWithdraws}
          />
          <hr className="wmin830 mv50"/>

          <PayoutsTable payouts={payouts}/>
        </WrapperWithLoading>
      </LayoutB>
    );
  };
});
